import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner, Table } from 'react-bootstrap';

const AiSchemaFieldNotesModal = ({ show, objectEntry, saving, onHide, onSave }) => {
  const [notes, setNotes] = useState({});

  useEffect(() => {
    if (!objectEntry) {
      setNotes({});
      return;
    }
    const initial = {};
    for (const field of objectEntry.fields || []) {
      initial[field.field_name] = field.note || '';
    }
    setNotes(initial);
  }, [objectEntry, show]);

  const handleSave = () => {
    onSave(notes);
  };

  if (!objectEntry) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop={saving ? 'static' : true} keyboard={!saving}>
      <Modal.Header closeButton={!saving}>
        <Modal.Title>Field descriptions — {objectEntry.object_label || objectEntry.object_name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small">
          Optional notes help the AI understand custom fields. Field names are synced from Object Manager.
        </p>
        <Table responsive size="sm" className="mb-0">
          <thead>
            <tr>
              <th style={{ width: '28%' }}>Field</th>
              <th style={{ width: '14%' }}>Type</th>
              <th>AI description</th>
            </tr>
          </thead>
          <tbody>
            {(objectEntry.fields || []).map((field) => (
              <tr key={field.field_name}>
                <td>
                  <div className="fw-semibold small">{field.field_label}</div>
                  <code className="small">{field.field_name}</code>
                </td>
                <td className="small text-muted">{field.data_type}</td>
                <td>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={notes[field.field_name] || ''}
                    disabled={saving}
                    placeholder="Optional hint for SQL generation"
                    onChange={(e) =>
                      setNotes((prev) => ({ ...prev, [field.field_name]: e.target.value }))
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={onHide} disabled={saving}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={saving} className="ai-dictionary-save-btn">
          {saving ? (
            <span className="d-inline-flex align-items-center">
              <Spinner animation="border" size="sm" className="me-2" />
              Saving…
            </span>
          ) : (
            'Save field notes'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AiSchemaFieldNotesModal;
